import React from 'react'
import { useHistory } from 'react-router-dom'
import './MyAccount.css'
import { Icon } from '../components/gp'

function AccountCard({ icon, title, subtitle, onClick }) {
    return (
        <button
            type="button"
            onClick={onClick}
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 18,
                padding: 22,
                background: 'var(--gp-card)',
                border: '1px solid var(--gp-hairline)',
                borderRadius: 'var(--gp-r-lg)',
                boxShadow: 'var(--gp-shadow-sm)',
                textAlign: 'left',
                color: 'inherit',
                cursor: 'pointer',
                font: 'inherit',
                transition:
                    'box-shadow 0.15s ease, transform 0.15s ease, border-color 0.15s ease',
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = 'var(--gp-shadow-md)'
                e.currentTarget.style.transform = 'translateY(-1px)'
                e.currentTarget.style.borderColor = 'var(--gp-accent)'
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = 'var(--gp-shadow-sm)'
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.borderColor = 'var(--gp-hairline)'
            }}
        >
            <div
                style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    background: 'var(--gp-lime-soft)',
                    color: 'var(--gp-brand)',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Icon name={icon} size={22} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                <div style={{ font: '500 16px/1.2 var(--gp-font)', color: 'var(--gp-ink)' }}>
                    {title}
                </div>
                <div style={{ font: 'var(--gp-caption)', color: 'var(--gp-ink-mute)' }}>
                    {subtitle}
                </div>
            </div>
            <div
                style={{
                    marginTop: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 4,
                    font: '500 13px/1 var(--gp-font)',
                    color: 'var(--gp-brand)',
                }}
            >
                Manage
                <Icon name="chevron" size={14} />
            </div>
        </button>
    )
}

const MyAccount = () => {
    const history = useHistory()
    const goTo = (where) => history.push(where)

    return (
        <div className="dashboard-page-container my-account-page">
            <h1 className="gp-page-title">My account</h1>
            <p className="gp-page-sub">Manage your sign-in and personal details.</p>

            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
                    gap: 18,
                    maxWidth: 880,
                }}
            >
                <AccountCard
                    icon="user"
                    title="Login & security"
                    subtitle="Email, password and account recovery"
                    onClick={() => goTo('/my-account/edit-login')}
                />
            </div>
        </div>
    )
}

export default MyAccount
